export const IMAGE_CDN = window.holidayFinder.img_cdn;
export const DEALS_PER_PAGE = 20;
export const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DATE_DDMMYYYY = 'dd/MM/yyyy';

export const BESTOUTOF_HIGH_NUMBER = 1000000;

export const REVIEW_SCORE_MULTIPLIER = 2;

let sPhoneTmp = '972506660993'; // HF
if (window.dataGlobalSettings?.marketId === 1) {
  if (window.dataGlobalSettings?.siteType === 1) {
    sPhoneTmp = '4915154941601'; // HH
  } else if (window.dataGlobalSettings?.siteType === 3) {
    sPhoneTmp = '4915151864728'; // hPRO
  }
}
const supportPhone = window.dataGlobalSettings?.whatsappButtonOnCheckoutPhone?.replace('+', '')?.replace(/[\u202A\u202B\u202C\u202D\u202E]/g, '') || sPhoneTmp;
export const BIG_GROUP_LINK = `https://api.whatsapp.com/send/?phone=${supportPhone}`;

export const CUSTOMIZE = Object.freeze({
  WHAT: 'what',
  WHERE: 'where',
  WHEN: 'when',
  WHO: 'who',
  FROMWHERE: 'fromwhere',
  FILTERS: 'filters'
})

export const DATE_TYPES = Object.freeze({
  MONTH: 'month',
  RANGE: 'range',
  SPECIFIC: 'specific'
})
